<template>
  <div class="mt-4 mb-2 ">
    <div class="layout row mb-2 ml-3">
      <div class="font-weight-medium mr-1 width-200">
        Date:
      </div>
      <div>{{ row.date | time }}</div>
    </div>
    <div class="layout row mb-2 ml-3">
      <div class="font-weight-medium mr-1 width-200">
        Entered On:
      </div>
      <div>{{ row.enteredOn | time }}</div>
    </div>

    <div class="layout row mb-2 ml-3" v-for="prop in getRowProperties()">
      <div class="font-weight-medium mr-1 width-200">{{ prop.name }}:</div>
      <div>{{ prop.value }}</div>
    </div>

    <div class="layout row mb-2 ml-3" v-if="row.datePrinted">
      <div class="font-weight-medium mr-1 width-200">
        Date Printed:
      </div>
      <div>{{ row.datePrinted | time }}</div>
    </div>
    <div class="layout row mb-2 ml-3" v-if="row.dateVoided">
      <div class="font-weight-medium mr-1 width-200">
        Date Voided:
      </div>
      <div>{{ row.dateVoided | time }}</div>
    </div>

    <div class="layout row mb-2 ml-3">
      <v-btn color="success" @click="openSmsDialog">
        Send SMS Notification
      </v-btn>
    </div>

    <v-dialog v-model="smsDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">
          Send SMS Notification
        </v-card-title>
        <v-text-field
          label="From Number"
          v-model="smsData.fromNumber"
          color="success"
          :rules="[rules.required, rules.phone]"
        ></v-text-field>
        <v-text-field
          label="To Number"
          v-model="smsData.toNumber"
          color="success"
          :rules="[rules.required, rules.phone]"
        ></v-text-field>
        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn @click="smsDialog = false" color="default" dark>
            Cancel
          </v-btn>
          <v-btn :loading="sending" color="success" @click="sendSms">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, formatCurrency } from "../../utils/helpers.js";

export default {
  props: {
    row: Object,
    columns: Array,
    reloadGrid: Function,
  },
  data() {
    return {
      smsDialog: false,
      sending: false,
      smsData: {
        fromNumber: "18775447264",
        toNumber: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
        phone: (value) => {
          if (!value) return true;
          const digits = value.replace(/[\s\-\(\)]/g, "");
          if (!/^\d+$/.test(digits)) return "Only digits allowed.";
          if (digits.length < 10 || digits.length > 11)
            return "Must be 10 or 11 digits.";
          if (digits.length === 11 && digits[0] !== "1")
            return "11-digit numbers must start with 1.";
          return true;
        },
      },
    };
  },
  async created() {},
  computed: {},
  methods: {
    getRowProperties() {
      return Object.keys(
        except(
          this.row,
          "vgt_id",
          "originalIndex",
          "vgtExpended",
          "enteredOn",
          "date",
          "datePrinted",
          "dateVoided"
        )
      )
        .map((key) => {
          const column = this.columns
            .filter((c) => !c.isIcon)
            .find((c) => c.field == key);

          return {
            name: column ? column.label : toTitleCase(key),
            value: this.row[key],
          };
        })
        .filter((p) => p.value);
    },
    formatTime(date) {
      return moment(date).format("MM/DD/YYYY h:mm:ss A");
    },
    openSmsDialog() {
      this.smsData.toNumber = this.row.phoneNumber || "";
      this.smsDialog = true;
    },
    formatPhoneNumber(value) {
      // Remove all non-digit characters
      let digits = value.replace(/\D/g, "");
      // Add leading 1 if not present
      if (digits.length === 10) {
        digits = "1" + digits;
      }
      return digits;
    },
    validatePhone(value) {
      const digits = value.replace(/\D/g, "");
      if (digits.length < 10 || digits.length > 11) return false;
      if (digits.length === 11 && digits[0] !== "1") return false;
      return true;
    },
    async sendSms() {
      if (!this.smsData.fromNumber || !this.smsData.toNumber) {
        return this.$notify({
          group: "notification",
          text: "Please fill in all fields",
          type: "error",
        });
      }

      if (
        !this.validatePhone(this.smsData.fromNumber) ||
        !this.validatePhone(this.smsData.toNumber)
      ) {
        return this.$notify({
          group: "notification",
          text: "Please enter valid phone numbers",
          type: "error",
        });
      }

      try {
        this.sending = true;

        const isLocalhost = window.location.hostname === "localhost";
        const apiUrl = isLocalhost
          ? "https://localhost:44360/teachers/SendTipSms"
          : "https://api-3t6ck5zrrq-ue.a.run.app/teachers/SendTipSms";

        await this.$http.post(apiUrl, {
          fromNumber: this.formatPhoneNumber(this.smsData.fromNumber),
          phoneNumber: this.formatPhoneNumber(this.smsData.toNumber),
          user: this.$store.state.authentication.user,
          tipID: this.row.id,
        });

        this.$notify({
          group: "notification",
          text: "SMS sent successfully",
          type: "success",
        });

        this.sending = false;
        this.smsDialog = false;
      } catch (e) {
        this.sending = false;
        // this.$notify({
        //   group: "notification",
        //   text: "Failed to send SMS",
        //   type: "error",
        // });
      }
    },
  },
};
</script>
<style></style>
